module.exports = __webpack_public_path__ + "static/media/main-small-section-right-2.e7ece130.png";